import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';
import Overview from './Overview';
import Conditions from './Conditions';

export default function Router(): ReactElement {
    return (
        <Switch>
            <Route exact={true} path='/loans/:loanUuid/drawdowns/:loanDrawdownUuid' component={Overview} />
            <Route exact={true} path='/loans/:loanUuid/drawdowns/:loanDrawdownUuid/conditions' component={Conditions} />
        </Switch>
    );
}